import { AfterViewInit, Component, OnInit, Output, Input, ElementRef, EventEmitter, ViewChild, OnDestroy } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LoginService, UsuarioService } from "../../../services/";
import { API } from "../../../app.config";
import * as moment from "moment";

import SignaturePad from "signature_pad";

@Component({
    selector: "assinatura-form",
    templateUrl: "./assinatura-form.component.html",
    styleUrls: ["./assinatura-form.component.scss"],
})
export class AssinaturaFormComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild("sPad") signaturePadElement?: ElementRef;
    signaturePad: any;

    private sPad: ElementRef;

    @ViewChild("sPad") set content(content: ElementRef) {
        if (content) {
            this.sPad = content;
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.inicializarCanvas();
        }, 100);
    }

    @Output()
    alterou = new EventEmitter<any>();

    usuario: any;
    Api = API;
    private resizeListener: any;

    /**
     * Verifica se o usuário precisa assinar contratos e se a assinatura não está registrada
     */
    get precisaAssinar(): boolean {
        return this.usuario.flAssinaContrato === true && this.usuario.AssinaturaDigitalizada == null;
    }

    constructor(
        private loginService: LoginService,
        private usuarioService: UsuarioService,
        private modalService: NgbModal
    ) {
        this.usuario = this.loginService.user();

        this.usuario.DataNascimento =
            this.usuario.DataNascimento != null ? moment(this.usuario.DataNascimento) : this.usuario.DataNascimento;
    }

    ngOnInit() {}

    /**
     * Inicializa o canvas de assinatura com as dimensões corretas
     */
    inicializarCanvas(): void {
        if (this.signaturePadElement != undefined && this.signaturePadElement.nativeElement != undefined) {
            const canvas = this.signaturePadElement.nativeElement;
            const container = canvas.parentElement;

            if (container) {
                // Obtém a largura do container
                const containerWidth = container.clientWidth - 20; // Subtrai o padding
                const canvasHeight = 200;

                // Define as dimensões do canvas em pixels
                canvas.width = containerWidth;
                canvas.height = canvasHeight;

                // Inicializa o SignaturePad
                this.signaturePad = new SignaturePad(canvas);

                // Adiciona listener para redimensionar quando a janela mudar de tamanho
                this.resizeListener = () => {
                    const newWidth = container.clientWidth - 20;
                    if (canvas.width !== newWidth) {
                        const data = this.signaturePad.toDataURL();
                        canvas.width = newWidth;
                        canvas.height = canvasHeight;
                        this.signaturePad = new SignaturePad(canvas);
                        if (data !== this.signaturePad.toDataURL()) {
                            const img = new Image();
                            img.src = data;
                            img.onload = () => {
                                const ctx = canvas.getContext("2d");
                                ctx.drawImage(img, 0, 0);
                            };
                        }
                    }
                };
                window.addEventListener("resize", this.resizeListener);
            } else {
                // Fallback: usa dimensões padrão
                canvas.width = 555;
                canvas.height = 200;
                this.signaturePad = new SignaturePad(canvas);
            }
        }
    }

    ngOnDestroy(): void {
        // Remove o listener de resize quando o componente for destruído
        if (this.resizeListener) {
            window.removeEventListener("resize", this.resizeListener);
        }
    }

    /**
     * Fecha o modal, mas impede o fechamento se a assinatura for obrigatória e não estiver registrada
     */
    fecharModal() {
        if (this.precisaAssinar) {
            alert("É necessário registrar a assinatura digitalizada antes de fechar a janela.");
            return;
        }

        this.modalService.dismissAll();
    }

    savePNG() {
        if (this.signaturePad.isEmpty()) {
            alert("Por favor, forneça uma assinatura primeiro.");
        } else {
            const dataURL = this.signaturePad.toDataURL();
            this.uploadAssinatura(dataURL);
        }
    }

    /**
     * Faz upload da assinatura digitalizada e atualiza o usuário no localStorage
     */
    uploadAssinatura(imagem) {
        this.usuarioService.uploadAssinatura(imagem, this.usuario.Id).subscribe(
            dados => {
                // Atualiza o objeto local
                this.usuario.AssinaturaDigitalizada = "/uploads/usuario/" + dados;

                // Recarrega os dados completos do usuário do backend para garantir sincronização
                this.loginService.getUserById(this.usuario.Id).subscribe(
                    dadosUsuario => {
                        let user = dadosUsuario.Items[0];
                        delete user.Perfis;
                        delete user.Roles;
                        delete user.Alteracoes;
                        if (user.Cidade && user.Cidade.Alteracoes) {
                            delete user.Cidade.Alteracoes;
                        }

                        // Preserva o token e outras informações de autenticação
                        const usuarioAtual = this.loginService.user();
                        if (usuarioAtual) {
                            user.access_token = usuarioAtual.access_token;
                            user.token_expire = usuarioAtual.token_expire;
                            if (usuarioAtual.portal) {
                                user.portal = usuarioAtual.portal;
                            }
                        }

                        // Atualiza o localStorage com os dados atualizados
                        window.localStorage.setItem("loggedUser", JSON.stringify(user));

                        // Atualiza o objeto local do componente
                        this.usuario = user;
                        this.usuario.DataNascimento =
                            this.usuario.DataNascimento != null ? moment(this.usuario.DataNascimento) : this.usuario.DataNascimento;

                        // Emite evento para notificar componentes pais (como o header) que o usuário foi atualizado
                        this.alterou.emit({ apenasAssinatura: true });

                        // Fecha o modal após atualizar a assinatura
                        setTimeout(() => {
                            this.modalService.dismissAll();
                        }, 500);
                    },
                    erro => {
                        console.log("Erro ao recarregar dados do usuário após upload da assinatura");
                        console.log(erro);
                        // Mesmo em caso de erro, atualiza o localStorage com o valor local
                        const usuarioAtual = this.loginService.user();
                        if (usuarioAtual) {
                            usuarioAtual.AssinaturaDigitalizada = this.usuario.AssinaturaDigitalizada;
                            window.localStorage.setItem("loggedUser", JSON.stringify(usuarioAtual));
                        }
                    }
                );
            },
            erros => {
                console.log("Erro ao fazer upload da assinatura");
                console.log(erros);
            }
        );
    }

    limpar() {
        this.signaturePad.clear();
    }
}

